export default __webpack_public_path__ + "static/media/bk-feature-1.d653e285.png";